import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useStateContext } from "../contexts/ContextProvider";
import { Row, Col, Button, Alert, Modal } from "react-bootstrap";
import LabelWithAsterisk from "../helpers/LabelWithAsterisk ";

const userInitialValues = {
  firstname: "",
  lastname: "",
  email: "",
  role: "",
  status: "active",
};

const userValidationSchema = Yup.object({
  firstname: Yup.string()
    .required("First Name is required")
    .min(1, "Too Short!")
    .max(50, "Too Long!"),
  lastname: Yup.string()
    .required("Last Name is required")
    .min(1, "Too Short!")
    .max(50, "Too Long!"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  role: Yup.string().required("Role is required"),
  status: Yup.string().required("Status is required"),
});

const AddUserForm = ({ roles, selectedUser, handleFormSubmit, isUser }) => {
  const { currentColor, currentMode } = useStateContext();

  const getUserInitialValues = () => {
    if (selectedUser) {
      return {
        firstname: selectedUser.firstname || "",
        lastname: selectedUser.lastname || "",
        email: selectedUser.email || "",
        role: selectedUser.role?._id || "",
        status: selectedUser.status || "",
      };
    }
    return userInitialValues;
  };

  return (
    <Formik
      initialValues={getUserInitialValues()}
      validationSchema={userValidationSchema}
      onSubmit={handleFormSubmit}
      enableReinitialize
    >
      {({ values, handleChange, handleBlur, isSubmitting }) => (
        <Form className="w-full p-2">
          <Row className="mb-0">
            <Col>
              <div className="form-group custom-form-group">
                <label htmlFor="firstname" className="custom-form-label">
                  <LabelWithAsterisk label="First Name" />
                </label>
                <Field
                  type="text"
                  name="firstname"
                  id="firstname"
                  value={values.firstname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  className="form-control custom-form-control border-secondary"
                />
                <ErrorMessage
                  name="firstname"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
            </Col>
            <Col>
              <div className="form-group custom-form-group">
                <label htmlFor="lastname" className="custom-form-label">
                  <LabelWithAsterisk label="Last Name" />
                </label>
                <Field
                  type="text"
                  name="lastname"
                  id="lastname"
                  value={values.lastname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  className="form-control custom-form-control border-secondary"
                />
                <ErrorMessage
                  name="lastname"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col>
              <div className="form-group custom-form-group">
                <label htmlFor="email" className="custom-form-label">
                  <LabelWithAsterisk label="Email" />
                </label>
                <Field
                  type="email"
                  name="email"
                  id="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  className="form-control custom-form-control border-secondary"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
            </Col>
            {isUser && (
              <Col>
                <div className="form-group custom-form-group">
                  <label htmlFor="role" className="custom-form-label">
                    <LabelWithAsterisk label="Role" />
                  </label>
                  <Field
                    as="select"
                    name="role"
                    id="role"
                    value={values.role}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    className="form-control custom-form-control border-secondary"
                  >
                    <option value="">Select a role</option>
                    {roles.map((role) => (
                      <option key={role._id} value={role._id}>
                        {role.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="role"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>
              </Col>
            )}
          </Row>

          <Row className="mb-0">
            <Col>
              <div className="form-group custom-form-group">
                <label className="custom-form-label">
                  <LabelWithAsterisk label="Status" />
                </label>
                <div role="group" aria-labelledby="status" className="mt-1">
                  <label className="inline-flex items-center mr-2">
                    <Field
                      type="radio"
                      name="status"
                      value="active"
                      checked={values.status === "active"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      className="custom-form-control border-secondary"
                    />
                    Active
                  </label>
                  <label className="inline-flex items-center">
                    <Field
                      type="radio"
                      name="status"
                      value="inactive"
                      checked={values.status === "inactive"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      className="custom-form-control border-secondary"
                    />
                    Inactive
                  </label>
                </div>
                <ErrorMessage
                  name="status"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>
            </Col>
          </Row>

          <Button
            type="submit"
            disabled={isSubmitting}
            className="mt-1 custom-form-button"
            style={{ backgroundColor: currentColor, color: "white" }}
          >
            {selectedUser ? "Update" : "ADD"}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default AddUserForm;
